<template>
    <td-dialog
        v-dialogDrag
        :title="$t(title)"
        :before-close="resourceDialogClose"
        :visible.sync="dialogResourceVisible"
        :width="dialogWidth"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formResourceInfo" :label-width="formLabelWidth" ref="formResourceInfo" :rules="rules">
            <el-form-item :label="$t('common.ID')" prop="sSrcId">
                <el-col :span="17">
                    <td-input v-model="formResourceInfo.sSrcId" :maxlength="100" :disabled="autoIdDisabled"></td-input>
                </el-col>
                <el-col :span="2">
                    <td-checkbox v-if="autoShow" v-model="sIdChecked" ref="sIdChecked" @change="autoCreateId">{{ $t('common.AUTO_CREATE') }}</td-checkbox>
                </el-col>
            </el-form-item>
            <el-form-item :label="$t('common.NAME')" prop="sName">
                <td-input v-model="formResourceInfo.sName" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.ROLE')" prop="iType">
                <td-select v-model="formResourceInfo.iType" :options="optionsRole"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.BELONG_TO_QUEUE')" prop="channelId">
                <td-select v-model="formResourceInfo.channelId" :options="optionsQueue" pageSize="6" keys="sFromChannelId" text="sFromChannel"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.ROUTING_KEY')" prop="sRoutingkey">
                <el-popover placement="right" width="250" trigger="hover" :content="$t('common.ROUTING_KEY_RULE')">
                    <td-input :special-character-check="false" slot="reference" v-model="formResourceInfo.sRoutingkey"></td-input>
                </el-popover>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescription">
                <td-input type="textarea" :rows="2" style="width:200px;" v-model="formResourceInfo.sDescription" :maxlength="500"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formResourceInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="resourceDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogResourceVisible', 'editItem', 'isAddData'],
    created() {
        this.initMqChannelData();
        this.rules.sSrcId[0].required = false;
        if (this.rules.sSrcId.length > 2) {
            this.rules.sSrcId[1].required = false;
            this.rules.sSrcId[2].required = false;
        }
        if (!this.isAddData) {
            this.dialogWidth = '340px';
        }
    },
    // 定义变量
    data() {
        let validateName = (rule, value, callback) => {
            let sSrcId = '';
            if (!this.isAddData) {
                sSrcId = this.editItem.sSrcId;
            }
            let param = {
                sSrcId: sSrcId,
                sName: value
            };
            resourceApi.checkResNameRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('dialogResourceInfo/checkResNameRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgMessage.RESOURCE_NAME_EXIST_PLEASE_INPUT'));
                    this.loading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        let validateId = (rule, value, callback) => {
            let param = {
                sSrcId: value
            };
            resourceApi.checkResIdRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('dialogResourceInfo/checkResIdRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgMessage.RESOURCE_ID_EXIST_PLEASE_INPUT'));
                    this.loading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            // 表单信息
            formResourceInfo: {
                sSrcId: '',
                sName: '',
                iType: '0',
                sRoutingkey: '',
                sDescription: '',
                channelId: ''
            },
            sIdChecked: true,
            autoIdDisabled: true,
            autoShow: true,

            // 角色类型类型转换
            optionsRole: [
                {
                    value: '0',
                    label: this.$t('common.PRODUCER')
                },
                {
                    value: '1',
                    label: this.$t('common.CONSUMER')
                }
            ],
            // 队列信息列表
            optionsQueue: [],
            formLabelWidth: '90px',
            dialogWidth: '430px',
            // 对表单进行数据验证
            rules: {
                channelId: [{ required: true, message: this.$t('error.ERROR_BELONG_QUEUE_NULL'), trigger: 'change' }],
                sSrcId: [
                    { required: this.autoIdDisabled, message: this.$t('pgError.ERROR_RES_ID_NULL'), trigger: 'change' },
                    { pattern: this.$regex.QUEUE_CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: validateName, trigger: 'blur' }
                ],
                iType: [{ required: true, message: this.$t('error.ERROR_INPUT_ROLE'), trigger: 'change' }],
                sRoutingkey: [{ pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }]
            },
            saveLoading: false
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formResourceInfo.sSrcId = this.editItem.sSrcId;
            this.formResourceInfo.sName = this.editItem.sName;
            this.formResourceInfo.iType = String(this.editItem.iType);
            this.formResourceInfo.sRoutingkey = this.editItem.sRoutingKey;
            this.formResourceInfo.sDescription = this.editItem.sDescription;
            this.formResourceInfo.channelId = this.editItem.channelId;
        },
        // 初始化队列下拉列表数据
        initMqChannelData() {
            resourceApi.getMqChannerList({}, response => {
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/dialogResourceInfo/getMqChannerList', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/dialogResourceInfo/getMqChannerList', response.data.statusMessage);
                    return;
                }
                this.optionsQueue = response.data.content;
                if (!this.isAddData) {
                    this.autoShow = false;
                    this.initEditData();
                } else {
                    if (this.optionsQueue.length > 0) {
                        this.formResourceInfo.channelId = this.optionsQueue[0].sFromChannelId;
                    }
                }
            });
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    let content = {
                        sSrcId: this.formResourceInfo.sSrcId,
                        sName: this.formResourceInfo.sName,
                        iType: this.formResourceInfo.iType,
                        sRoutingKey: this.formResourceInfo.sRoutingkey,
                        sDescription: this.formResourceInfo.sDescription,
                        channelId: this.formResourceInfo.channelId
                    };
                    if (this.isAddData) {
                        resourceApi.addResource(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogResourceInfo/addResource', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.saveLoading = false;
                            this.resourceDialogClose();
                            this.$emit('queryDataList');
                        });
                    } else {
                        content.sid = this.editItem.sId;
                        resourceApi.updateResource(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogResourceInfo/updateResource', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.saveLoading = false;
                            this.resourceDialogClose();
                            this.$emit('queryDataList');
                        });
                    }
                }
            });
        },

        // 自动生成id
        autoCreateId() {
            let validateName = (rule, value, callback) => {
                let sSrcId = '';
                if (!this.isAddData) {
                    sSrcId = this.editItem.sSrcId;
                }
                let param = {
                    sSrcId: sSrcId,
                    sName: value
                };
                resourceApi.checkResNameRepeat(JSON.stringify(param), response => {
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$log.error('dialogResourceInfo/checkResNameRepeat', response);
                    }
                    if (response.data.content) {
                        callback(this.$t('pgMessage.RESOURCE_NAME_EXIST_PLEASE_INPUT'));
                        this.loading = false;
                        return;
                    } else {
                        callback();
                    }
                });
            };
            let validateId = (rule, value, callback) => {
                let param = {
                    sSrcId: value
                };
                resourceApi.checkResIdRepeat(JSON.stringify(param), response => {
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$log.error('dialogResourceInfo/checkResIdRepeat', response);
                    }
                    if (response.data.content) {
                        callback(this.$t('pgMessage.RESOURCE_ID_EXIST_PLEASE_INPUT'));
                        this.loading = false;
                        return;
                    } else {
                        callback();
                    }
                });
            };
            this.rules = {
                channelId: [{ required: true, message: this.$t('error.ERROR_BELONG_QUEUE_NULL'), trigger: 'change' }],
                sSrcId: [
                    { required: true, message: this.$t('pgError.ERROR_RES_ID_NULL'), trigger: 'change' },
                    { required: true, pattern: this.$regex.QUEUE_CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { required: true, validator: validateId, trigger: 'blur' }
                ],
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: validateName, trigger: 'blur' }
                ],
                iType: [{ required: true, message: this.$t('error.ERROR_INPUT_ROLE'), trigger: 'change' }],
                sRoutingkey: [{ pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }]
            };
            if (!this.isAddData) {
                return;
            }
            if (this.autoIdDisabled) {
                this.autoIdDisabled = false;
                this.rules.sSrcId[0].required = true;
                this.rules.sSrcId[1].required = true;
                this.rules.sSrcId[2].required = true;
            } else {
                this.formResourceInfo.sSrcId = null;
                this.autoIdDisabled = true;
                this.rules.sSrcId[0].required = false;
                this.rules.sSrcId[1].required = false;
                this.rules.sSrcId[2].required = false;
            }
        },

        // 关闭窗口之前需要调用的方法
        resourceDialogClose() {
            this.$emit('resourceDialogClose');
            this.$refs['formResourceInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
